import React from "react";
import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const MBAFinalCTA = () => {
  return (
    <section className="bg-primary text-white py-14 md:py-20 px-4">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-16">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 font-poppins text-secondary text-sm font-extrabold tracking-widest uppercase mb-4">
              <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
              Lead at the next level
            </p>
            <h2 className="font-poppins text-white font-bold tracking-tight text-3xl md:text-4xl mb-3 max-w-xl">
              Build the business confidence to lead across borders.
            </h2>
            <p className="font-poppins text-blue-100 text-sm m-0">
              Five months of practical learning, five global university
              partnerships and a capstone you can defend.
            </p>
          </div>
        </Animate.Fade>
        <Animate.Fade bottom>
          <div className="flex flex-wrap items-center gap-5">
            <Link
              to="/mba/apply"
              className="text-primary bg-secondary custom-btn px-7 py-4 text-center rounded-xl inline-flex items-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Apply now{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </Link>
            <a
              href="#scholarships"
              className="text-white font-poppins text-sm font-bold underline underline-offset-4"
            >
              View scholarships
            </a>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default MBAFinalCTA;
